<!-- src/components/ClientLandingPage.vue - ENHANCED VERSION -->
<template>
  <div class="client-landing">
    <!-- Header -->
   
<div class="header">
  <div class="company-info">
    <h1>
      <i class="fas fa-building"></i>
      {{ profile.company_name || 'Welcome..' }}
    </h1>
    <div class="company-meta">
      <span v-if="profile.industry" class="meta-item">
        <i class="fas fa-industry"></i>
        {{ profile.industry }}
      </span>
      <span v-if="profile.contact_email" class="meta-item">
        <i class="fas fa-users"></i>
        {{ profile.contact_email }} 
      </span>
      <span v-if="profile.region" class="meta-item">
        <i class="fas fa-map-marker-alt"></i>
        {{ profile.region }}
      </span>
    </div>
  </div>
  <!-- <div class="tier-badge" :class="tierClass">
    <i class="fas fa-crown"></i>
    {{ profile.tier_name || 'BASIC' }} Plan
  </div> -->
</div>
    <!-- <div style="background: rgba(0,0,0,0.3); color: white; padding: 1rem; margin: 1rem 2rem; border-radius: 0.5rem; font-family: monospace; font-size: 0.875rem;">
      <strong>🐛 DEBUG INFO:</strong><br>
      Loading: {{ loading }}<br>
      Projects loaded: {{ projects.length }}<br>
      Profile loaded: {{ profile.company_name || 'No company name' }}<br>
      Show empty state: {{ projects.length === 0 && !loading }}<br>
      Show projects section: {{ projects.length > 0 }}<br>
      <br>
      <details>
        <summary>Raw projects data (click to expand)</summary>
        <pre style="font-size: 0.75rem; max-height: 200px; overflow: auto; background: rgba(0,0,0,0.2); padding: 0.5rem; margin-top: 0.5rem;">{{ JSON.stringify(projects, null, 2) }}</pre>
      </details>
    </div> -->

    <!-- Main Content -->
    <div class="main-content">
      <!-- No Projects State -->
      <div v-if="projects.length === 0 && !loading" class="empty-state">
        <div class="empty-icon">
          <i class="fas fa-briefcase"></i>
        </div>
        <h2>Ready to find your next hire?</h2>
        <p>Create your first recruitment project to get started with our talent search platform.</p>
        <button @click="showCreateProject = true" class="create-first-btn">
          <i class="fas fa-plus"></i>
          Create Your First Project
        </button>
      </div>

      <!-- Projects Banners -->
      <div v-else class="projects-section">
        <div class="section-header">
          <h2>Your Recruitment Projects</h2>
          <div class="header-actions">
            <router-link to="/client/projects" class="view-all-btn">
              <i class="fas fa-th-list"></i>
             Manage Your Projects
            </router-link>
            <button 
              @click="showCreateProject = true" 
              class="create-btn"
              :disabled="!canCreateProject"
            >
              <i class="fas fa-plus"></i>
              New Project
            </button>
          </div>
        </div>

       
        <div class="projects-banners">
          <div 
            v-for="project in enhancedProjects" 
            :key="project.project_id"
            class="project-banner"
            :class="[project.urgencyClass, { 'project-inactive': project.status !== 'ACTIVE' }]"
            @click="selectProject(project)"
          >
            <!-- Compact Banner Content -->
            <div class="banner-content">
              <!-- Smaller Project Icon -->
              <div class="project-icon">
                <i class="fas fa-briefcase"></i>
              </div>
              
              <!-- Simplified Project Info -->
              <div class="project-info">
                <!-- Project name as primary, no company name -->
                <div class="project-main">
                  <span class="project-name-primary">{{ project.project_name }}</span>
                  <span class="project-status-badge" :class="project.status.toLowerCase()">
                    {{ project.status }}
                  </span>
                </div>
                
                <!-- Simplified meta info -->
                <div class="project-meta">
                  <span class="job-title">{{ project.job_title }}</span>
                  <!-- <span class="tier-info">{{ project.tier_name }}</span>
                  <span class="budget-info">$$$ -->
                    <!-- {{ project.base_price_usd.toLocaleString() }} -->
                  <!-- </span> -->
                </div>
                
                <!-- Compact progress -->
                <div class="project-progress">
                  <div class="positions-info">
                    <span class="positions-text">{{ project.positions_filled }}/{{ project.positions_required }} filled</span>
                    <div class="progress-bar">
                      <div 
                        class="progress-fill" 
                        :style="{ width: getProgressPercentage(project) + '%' }"
                      ></div>
                    </div>
                  </div>
                  
                  <div v-if="project.daysRemaining !== null" class="urgency-info">
                    <span v-if="project.daysRemaining >= 0" class="days-remaining">
                      {{ project.daysRemaining }}d left
                    </span>
                    <span v-else class="overdue-text">
                      {{ Math.abs(project.daysRemaining) }}d overdue
                    </span>
                  </div>
                </div>
              </div>
              
              <!-- Compact action button -->
              <div class="project-actions">
                <button 
                  v-if="project.daysRemaining !== null && project.daysRemaining <= 15" 
                  @click="requestExtension(project, $event)" 
                  class="extension-btn"
                >
                  <i class="fas fa-clock"></i>
                  Extend
                </button>
                <button
  @click.stop="hideProject(project)"
  class="hide-btn"
  title="Archiver ce projet"
>
  <i class="fas fa-eye-slash"></i>
</button>
              </div>
            </div>
          </div>
        </div>



      </div>
      <!-- Archive Toggle -->
<div class="archive-footer">
  <button @click="toggleArchive" class="archive-toggle-btn">
    <i :class="showArchived ? 'fas fa-chevron-up' : 'fas fa-archive'"></i>
    {{ showArchived ? 'Masquer les archives' : 'Voir les projets archivés' }}
    <span v-if="archivedProjects.length" class="archive-count">{{ archivedProjects.length }}</span>
  </button>
</div>

<div v-if="showArchived" class="archived-section">
  <div v-if="archivedProjects.length === 0" class="archive-empty">
    <i class="fas fa-box-open"></i> Aucun projet archivé
  </div>
  <div
    v-for="project in archivedProjects"
    :key="project.project_id"
    class="archived-banner"
  >
    <div class="archived-info">
      <span class="archived-name">{{ project.project_name }}</span>
      <span class="archived-job">{{ project.job_title }}</span>
    </div>
    <button @click="restoreProject(project)" class="restore-btn">
      <i class="fas fa-eye"></i> Restaurer
    </button>
  </div>
</div>



      
      <!-- Create Project Form Modal - UNCHANGED -->
<!-- Create Project Modal -->
<!-- Replace your existing create project modal template with this -->

<!-- Create Project Modal -->
<div v-if="showCreateProject" class="modal-overlay" >
  <div class="modal-content" @click.stop>
    <div class="modal-header">
      <h2>
        <i class="fas fa-plus-circle"></i>
        Create New Recruitment Project
      </h2>
      <button @click="closeCreateProject" class="close-btn">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <form @submit.prevent="createProject" class="project-form">
      <!-- Step Indicator -->
      <div class="form-steps">
        <div class="step" :class="{ active: formStep === 1, completed: formStep > 1 }">
          <span class="step-number">1</span>
          <span class="step-label">Project Details</span>
        </div>
        <div class="step-divider"></div>
        <div class="step" :class="{ active: formStep === 2 }">
          <span class="step-number">2</span>
          <span class="step-label">Role Requirements</span>
        </div>
      </div>

      <!-- Step 1: Basic Project Details -->
      <div v-show="formStep === 1" class="form-step-content">
        <h3>Project Information</h3>
        
        <div class="form-row">
          <div class="form-group">
            <label for="project_name">Project Name *</label>
            <input
              id="project_name"
              v-model="newProject.project_name"
              type="text"
              placeholder="e.g., 'Senior Backend Engineer Search'"
              required
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group half-width">
            <label for="positions_required">Positions to Fill *</label>
            <input
              id="positions_required"
              v-model.number="newProject.positions_required"
              type="number"
              min="1"
              max="50"
              required
            />
          </div>
          
          <!-- <div class="form-group half-width">
            <label for="project_tier">Project Tier *</label>
            <select 
              id="project_tier"
              v-model="newProject.project_tier_id"
              required
            >
              <option value="">Select tier...</option>
              <option 
                v-for="tier in projectTiers" 
                :key="tier.project_tier_id"
                :value="tier.project_tier_id"
              >
                {{ tier.tier_name }} - $$$
                <!-- {{ tier.base_price_usd.toLocaleString() }} -->
              <!-- </option> 
            </select>
          </div> -->
        </div>

        <div class="form-actions">
          <div></div> <!-- Empty div for spacing -->
          <button
            type="button"
            @click="nextFormStep"
            :disabled="!isBasicFormValid"
            class="next-btn"
          >
            Next: Role Requirements
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- Step 2: Role Requirements -->
      <div v-show="formStep === 2" class="form-step-content">
        <h3>Role Requirements</h3>
        
        <div class="form-row">
          <div class="form-group">
            <label for="job_title">Job Title *</label>
            <input
              id="job_title"
              v-model="newProject.job_title"
              type="text"
              placeholder="e.g., Senior Full-Stack Engineer"
              required
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group half-width">
            <label for="seniority_level">Seniority Level *</label>
            <select
              id="seniority_level"
              v-model="newProject.seniority_level"
              required
            >
              <option value="">Select seniority...</option>
              <option 
                v-for="level in seniorityOptions" 
                :key="level.value"
                :value="level.value"
              >
                {{ level.label }}
              </option>
            </select>
          </div>
          
          <div class="form-group half-width">
            <label>Years of Experience: {{ experienceRangeLabel }}</label>
            <div class="experience-controls">
              <!-- Experience Range Slider -->
              <input
                type="range"
                v-model.number="newProject.years_experience_min"
                :min="0"
                :max="60"
                :step="6"
                @input="onExperienceRangeChange"
                class="range-input min-range"
              />
              <input
                type="range"
                v-model.number="newProject.years_experience_max"
                :min="0"
                :max="60"
                :step="6"
                @input="onExperienceRangeChange"
                class="range-input max-range"
              />
              
              <!-- Experience Presets -->
              <div class="experience-presets">
                <button 
                  type="button"
                  class="preset-btn"
                  @click="setExperiencePreset([0, 60])"
                  :class="{ active: newProject.years_experience_min === 0 && newProject.years_experience_max === 60 }"
                >
                  Any
                </button>
                <button 
                  type="button"
                  class="preset-btn"
                  @click="setExperiencePreset([6, 24])"
                  :class="{ active: newProject.years_experience_min === 6 && newProject.years_experience_max === 24 }"
                >
                  6m-2y
                </button>
                <button 
                  type="button"
                  class="preset-btn"
                  @click="setExperiencePreset([24, 60])"
                  :class="{ active: newProject.years_experience_min === 24 && newProject.years_experience_max === 60 }"
                >
                  2y-5y+
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="detailed_job_description">Detailed Job Description *</label>
            <textarea
              id="detailed_job_description"
              v-model="newProject.detailed_job_description"
              rows="6"
              placeholder="Paste your LinkedIn job posting or describe the role, responsibilities, required skills, and qualifications..."
              required
            ></textarea>
            <small class="field-hint">
              <i class="fas fa-info-circle"></i>
              Tip: You can copy-paste directly from LinkedIn or other job boards
            </small>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="additional_context">Additional Context (Optional)</label>
            <textarea
              id="additional_context"
              v-model="newProject.additional_context"
              rows="3"
              placeholder="Company culture, team structure, specific sourcing preferences, domain focus, or other requirements..."
            ></textarea>
          </div>
        </div>

        <!-- Attachments / Links -->
<div class="form-group">
  <label>
    <i class="fas fa-paperclip"></i> Pièces jointes / Liens
  </label>
  <div v-for="(link, idx) in newProject.project_links" :key="idx" class="link-entry">
    <input
      type="text"
      v-model="newProject.project_links[idx].label"
      placeholder="Nom du lien (ex: Fiche de poste)"
      class="link-label-input"
    />
    <input
      type="text"
      v-model="newProject.project_links[idx].url"
      placeholder="https://..."
      class="link-url-input"
    />
    <button type="button" class="remove-link-btn" @click="newProject.project_links.splice(idx, 1)">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <button
    type="button"
    class="btn-add-date"
    @click="newProject.project_links.push({ label: '', url: '' })"
  >
    <i class="fas fa-plus"></i> Ajouter un lien
  </button>
</div>
        <div class="form-actions">
          <button
            type="button"
            @click="previousFormStep"
            class="back-btn"
          >
            <i class="fas fa-arrow-left"></i>
            Back
          </button>
          
          <button
            type="submit"
            :disabled="creating || !canSubmitProject"
            class="submit-btn"
          >
            <i class="fas fa-spinner fa-spin" v-if="creating"></i>
            <i class="fas fa-plus" v-else></i>
            {{ creating ? 'Creating Project...' : 'Create Project' }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
<!-- Contract Preview Modal -->
<!-- <div v-if="showContractPreview" class="modal-overlay">
  <div class="modal-content" style="width: 92%; max-width: 1100px; height: 92vh; display: flex; flex-direction: column; padding: 0;">
    <div class="modal-header" style="padding: 1.25rem; border-bottom: 1px solid #ddd;">
      <h2 style="margin: 0;">Project Contract Preview</h2>
      <button @click="closeContractPreview" class="close-btn">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div style="flex: 1; overflow: hidden; background: #f9f9f9;">
      <iframe
        :src="contractPreviewUrl"
        width="100%"
        height="100%"
        frameborder="0"
        title="Project Contract"
      ></iframe>
    </div>

    <div class="modal-footer" style="padding: 1rem 1.5rem; border-top: 1px solid #ddd; display: flex; justify-content: flex-end; gap: 1rem; background: white;">
      <button @click="downloadContract" class="btn btn-secondary">
        <i class="fas fa-download"></i> Download PDF
      </button>
      <button 
        @click="confirmAndCreateProject" 
        class="btn btn-primary"
        :disabled="creating"
      >
        <i v-if="creating" class="fas fa-spinner fa-spin"></i>
        <i v-else class="fas fa-check"></i>
        I Agree – Create Project
      </button>
    </div>
  </div>
</div> -->

      <!-- Loading State -->
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
        <p>Loading your projects...</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ClientLandingPage',
  emits: ['project-selected', 'notify', 'project-created'],
  
  data() {
    return {
      showArchived: false,
archivedProjects: [],
    // showContractPreview: false,
    // contractPreviewUrl: null,
    // formDataForContract: null,
      profile: {},
      projects: [],
      projectTiers: [],
      loading: true,
      creating: false,
      showCreateProject: false,


      newProject: {
        project_name: '',
        job_title: '',
        job_description: '',
        positions_required: 1,
        project_tier_id: 4,
        project_links: [] ,

        // NEW Stage 1 requirements fields
        seniority_level: null,
        years_experience_min: 0,
        years_experience_max: 60, // months, displayed as 5 years
        detailed_job_description: '',
        additional_context: ''
      },
    
    // NEW: Form validation and state
    showRequirementsSection: true,
    formStep: 1, // 1 = basic info, 2 = requirements
    
    // NEW: Dropdown options (matching SearchSection pattern)
    seniorityOptions: [
      { label: 'Junior', value: 'junior' },
      { label: 'Confirmed', value: 'confirmed' },
      { label: 'Senior', value: 'senior' },
      { label: 'Expert', value: 'expert' },
      { label: 'Consultant', value: 'consultant' }
    ]
  };
},

  computed: {
    tierClass() {
      const tier = (this.profile.tier_name || '').toLowerCase();
      return {
        'tier-basic': tier === 'basic',
        'tier-pro': tier === 'pro', 
        'tier-enterprise': tier === 'enterprise'
      };
    },
    
    canCreateProject() {
      const activeProjects = this.projects.filter(p => p.status === 'ACTIVE').length;
      return activeProjects < (this.profile.max_concurrent_projects || 2);
    },

    // NEW: Enhanced projects with urgency data
    enhancedProjects() {
      return this.projects.map(project => {
        const urgencyData = this.getUrgencyData(project);
         const isCompleted = project.status === 'COMPLETED';
         const progressPercentage = this.getProgressPercentage(project);
      
        return {
          ...project,
          ...urgencyData,
        isCompleted,
        progressPercentage,
        isClickable: !isCompleted, // Make completed projects unclickable
        statusClass: this.getProjectStatusClass(project),
        progressBarClass: isCompleted ? 'progress-completed' : ''
      };
        
      });
    },
    // NEW: Experience display helpers (matching SearchSection)
  experienceRangeLabel() {
    const minYears = this.experienceToYears(this.newProject.years_experience_min);
    const maxYears = this.experienceToYears(this.newProject.years_experience_max);
    
    if (this.newProject.years_experience_min === 0 && this.newProject.years_experience_max >= 60) {
      return 'Any experience';
    }
    
    if (this.newProject.years_experience_max >= 60) {
      return `${minYears}+ experience`;
    }
    
    if (this.newProject.years_experience_min === 0) {
      return `Up to ${maxYears} experience`;
    }
    
    return `${minYears} - ${maxYears} experience`;
  },
  
  // Form validation
  isBasicFormValid() {
    return this.newProject.project_name.trim() && 
           this.newProject.positions_required > 0 && 
           this.newProject.project_tier_id;
  },
  
  isRequirementsFormValid() {
    return this.newProject.job_title.trim() &&
           this.newProject.seniority_level &&
           this.newProject.detailed_job_description.trim();
  },
  
  canSubmitProject() {
    return this.isBasicFormValid && this.isRequirementsFormValid;
  }
  },
  
  async mounted() {
    await this.loadData();
  },
  
  methods: {
    async hideProject(project) {
  try {
    await axios.put(`/api/v1/projects/${project.project_id}/visibility`, null, {
      params: { visible: false }
    });
    await this.loadData();
    if (this.showArchived) await this.loadArchived();
  } catch (e) {
    this.$emit('notify', { type: 'error', message: 'Échec de l\'archivage' });
  }
},

async restoreProject(project) {
  try {
    await axios.put(`/api/v1/projects/${project.project_id}/visibility`, null, {
      params: { visible: true }
    });
    await this.loadData();
    await this.loadArchived();
  } catch (e) {
    this.$emit('notify', { type: 'error', message: 'Échec de la restauration' });
  }
},

async toggleArchive() {
  this.showArchived = !this.showArchived;
  if (this.showArchived && this.archivedProjects.length === 0) {
    await this.loadArchived();
  }
},

async loadArchived() {
  try {
    const res = await axios.get('/api/v1/clients/projects-archived');
    this.archivedProjects = res.data || [];
  } catch (e) {
    this.archivedProjects = [];
  }
},
   // NEW: Experience conversion helper (matching SearchSection)
  experienceToYears(months) {
    if (months === 0) return '0';
    if (months < 12) return `${months}m`;
    
    const years = months / 12;
    if (years % 1 === 0) {
      return `${years}y`;
    } else {
      const roundedYears = Math.round(years * 2) / 2;
      return `${roundedYears}y`;
    }
  },
  
  // NEW: Experience preset helpers
  setExperiencePreset(range) {
    this.newProject.years_experience_min = range[0];
    this.newProject.years_experience_max = range[1];
  },
  
  // NEW: Experience range change handler
  onExperienceRangeChange() {
    // Round to 6-month increments (matching SearchSection)
    this.newProject.years_experience_min = Math.round(this.newProject.years_experience_min / 6) * 6;
    this.newProject.years_experience_max = Math.round(this.newProject.years_experience_max / 6) * 6;
  },
  
  // NEW: Form step navigation
  nextFormStep() {
    if (this.formStep === 1 && this.isBasicFormValid) {
      this.formStep = 2;
    }
  },
  
  previousFormStep() {
    if (this.formStep === 2) {
      this.formStep = 1;
    }
  },
async loadData() {
  console.log('🔄 ClientLandingPage: Starting loadData()...');
  
  try {
    this.loading = true;
    
    console.log('📡 Making API calls...');
    
    // Test each API call individually to see which one is failing
    let profileResponse, projectsResponse, tiersResponse;
    
    try {
      console.log('📡 Calling /api/v1/clients/profile...');
      profileResponse = await axios.get('/api/v1/clients/profile');
      console.log('✅ Profile API success:', profileResponse.data);
    } catch (error) {
      console.error('❌ Profile API failed:', error.response?.status, error.response?.data);
      throw error;
    }
    
    try {
      console.log('📡 Calling /api/v1/clients/projects...');
      projectsResponse = await axios.get('/api/v1/clients/projects');
      console.log('✅ Projects API success:', projectsResponse.data);
      console.log('📊 Projects count:', Array.isArray(projectsResponse.data) ? projectsResponse.data.length : 'Not an array');
    } catch (error) {
      console.error('❌ Projects API failed:', error.response?.status, error.response?.data);
      throw error;
    }
    
    try {
      console.log('📡 Calling /api/v1/clients/project-tiers...');
      // tiersResponse = await axios.get('/api/v1/clients/project-tiers');
      // console.log('✅ Tiers API success:', tiersResponse.data);
    } catch (error) {
      console.error('❌ Tiers API failed:', error.response?.status, error.response?.data);
      throw error;
    }
    
    // Set the data
    this.profile = profileResponse.data;
    this.projects = projectsResponse.data || [];
    // this.projectTiers = tiersResponse.data || [];
    
    console.log('📋 Final data set:');
    console.log('  - Profile:', this.profile);
    console.log('  - Projects array:', this.projects);
    console.log('  - Projects length:', this.projects.length);
    // console.log('  - Projects tiers:', this.projectTiers.length);
    
    // Check template condition
    const showEmptyState = this.projects.length === 0 && !this.loading;
    const showProjectsSection = this.projects.length > 0;
    
    console.log('🎯 Template conditions:');
    console.log('  - projects.length:', this.projects.length);
    console.log('  - loading:', this.loading);
    console.log('  - Will show empty state:', showEmptyState);
    console.log('  - Will show projects section:', showProjectsSection);
    
  } catch (error) {
    console.error('❌ ClientLandingPage loadData error:', error);
    console.error('  - Status:', error.response?.status);
    console.error('  - Data:', error.response?.data);
    
    // Set fallbacks
    this.profile = {};
    this.projects = [];
    this.projectTiers = [];
    
    this.$emit('notify', {
      type: 'error',
      message: `Failed to load project data: ${error.response?.data?.detail || error.message}`
    });
  } finally {
    this.loading = false;
    console.log('🏁 ClientLandingPage loadData finished, loading =', this.loading);
  }
},
// closeContractPreview() {
//     this.showContractPreview = false;
//     if (this.contractPreviewUrl) {
//       URL.revokeObjectURL(this.contractPreviewUrl);
//       this.contractPreviewUrl = null;
//     }
//     this.projectPayloadToConfirm = null;
//   },

//   downloadContract() {
//     if (!this.contractPreviewUrl) return;

//     const link = document.createElement('a');
//     link.href = this.contractPreviewUrl;
//     link.download = `Red-Tic_Project_Contract_${this.newProject.project_name.replace(/\s+/g, '_')}.pdf`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);

//     this.$emit('notify', {
//       type: 'info',
//       message: 'Contract downloaded – review before confirming'
//     });
//   },

  // async confirmAndCreateProject() {
  //   if (!this.projectPayloadToConfirm) return;

  //   try {
  //     this.creating = true;

  //     // Now actually create the project
  //     const response = await axios.post(
  //       '/api/v1/clients/projects',
  //       this.projectPayloadToConfirm
  //     );

  //     // Success handling (your original logic)
  //     await this.loadData();
  //     this.closeCreateProject();
  //     this.closeContractPreview();

  //     this.$emit('notify', {
  //       type: 'success',
  //       message: `Project "${this.newProject.project_name}" created successfully!`
  //     });

  //     this.$emit('project-created', response.data);
  //     console.log('🚀 ClientLandingPage: Emitted project-created event');

  //   } catch (error) {
  //     console.error('Error creating project after confirmation:', error);
  //     this.$emit('notify', {
  //       type: 'error',
  //       message: error.response?.data?.detail || 'Failed to create project'
  //     });
  //   } finally {
  //     this.creating = false;
  //   }
  // },
   // ENHANCED: Create project method (modify existing)
   async createProject() {
  if (!this.canSubmitProject) {
    this.$emit('notify', {
      type: 'error',
      message: 'Please fill in all required fields'
    });
    return;
  }

  try {
    this.creating = true;

    // 1. Prepare the exact same payload you'll use for real creation
    const projectPayload = {
      project_name: this.newProject.project_name,
      job_title: this.newProject.job_title,
      job_description: this.newProject.detailed_job_description,
      positions_required: this.newProject.positions_required,
      project_tier_id: this.newProject.project_tier_id,
      project_links: this.newProject.project_links.filter(l => l.url.trim()),  // ← add this
      seniority_level: this.newProject.seniority_level?.value || this.newProject.seniority_level,
      years_experience_min: this.newProject.years_experience_min,
      years_experience_max: this.newProject.years_experience_max,
      detailed_job_description: this.newProject.detailed_job_description,
      additional_context: this.newProject.additional_context,

      // Stage 1 requirements (keeping your enhanced structure)
      // requirements: {
      //   seniority_level: this.newProject.seniority_level?.value || this.newProject.seniority_level,
      //   years_experience_min: this.newProject.years_experience_min,
      //   years_experience_max: this.newProject.years_experience_max,
      //   detailed_job_description: this.newProject.detailed_job_description,
      //   additional_context: this.newProject.additional_context
      // }
    };
      const response = await axios.post('/api/v1/clients/projects', projectPayload);
      await this.loadData();
    this.closeCreateProject();

    this.$emit('notify', { type: 'success', message: `Project "${this.newProject.project_name}" created successfully!` });
    this.$emit('project-created', response.data);

  } catch (error) {
    this.$emit('notify', { type: 'error', message: error.response?.data?.detail || 'Failed to create project' });
  } finally {
    this.creating = false;
  }
}

    // // 2. Get contract preview PDF (does NOT create anything yet)
    // const previewResponse = await axios.post(
    //   '/api/v1/clients/projects/preview-contract',
    //   projectPayload,
    //   { responseType: 'blob' }   // ← crucial for handling PDF binary
    // );

    // // Create temporary blob URL for iframe preview
    // const blob = new Blob([previewResponse.data], { type: 'application/pdf' });
    // this.contractPreviewUrl = URL.createObjectURL(blob);
    // this.projectPayloadToConfirm = projectPayload;  // save for later confirmation

    // // Show preview modal
    // this.showContractPreview = true;

//   } catch (error) {
//     console.error('Error generating contract preview:', error);
//     this.$emit('notify', {
//       type: 'error',
//       message: error.response?.data?.detail || 'Failed to generate contract preview'
//     });
//   } finally {
//     this.creating = false;
//   }
// },
  ,
    
  selectProject(project) {
    // Don't allow selection of completed projects
    if (project.status === 'COMPLETED') {
      // this.$emit('notify', {
      //   type: 'info',
      //   message: 'This project has been completed and is no longer active.'
      // });
      // return;
      // For completed projects, go to candidate pool view
      this.$router.push({
        name: 'CandidatePool',
        params: { projectId: project.project_id }
      });
      return;
    }
    
    this.$emit('project-selected', project);
  },
   getProjectStatusClass(project) {
    const statusClasses = {
      'ACTIVE': 'status-active',
      'COMPLETED': 'status-completed',
      'PAUSED': 'status-paused',
      'CANCELLED': 'status-cancelled'
    };
    return statusClasses[project.status] || 'status-default';
  },formatProjectStatus(status) {
    const statusMap = {
      'ACTIVE': 'Active',
      'COMPLETED': 'Completed',
      'PAUSED': 'Paused',
      'CANCELLED': 'Cancelled'
    };
    return statusMap[status] || status;
  },
    
     // ENHANCED: Close project form (reset new fields)
  closeCreateProject() {
    this.showCreateProject = false;
    this.formStep = 1;
    this.newProject = {
      // Reset basic fields
      project_name: '',
      job_title: '',
      job_description: '',
      positions_required: 1,
      project_tier_id: 4,
      
      // Reset new fields
      seniority_level: null,
      years_experience_min: 0,
      years_experience_max: 60,
      detailed_job_description: '',
      additional_context: '',
      project_links: []   // ← add

    };
  },
    
    getProgressPercentage(project) {
      if (project.positions_required === 0) return 0;
      return Math.min(100, (project.positions_filled / project.positions_required) * 100);
    },
    
    formatDate(dateStr) {
      return new Date(dateStr).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },

    // NEW: Calculate urgency based on end date
    getUrgencyData(project) {
      if (!project.end_date) {
        return { urgencyLevel: 'safe', urgencyClass: 'banner-safe', daysRemaining: null };
      }
      
      const today = new Date();
      const endDate = new Date(project.end_date);
      const timeDiff = endDate.getTime() - today.getTime();
      const daysRemaining = Math.ceil(timeDiff / (1000 * 3600 * 24));
      
      let urgencyLevel, urgencyClass;
      
      if (daysRemaining < 0) {
        urgencyLevel = 'overdue';
        urgencyClass = 'banner-overdue';
      } else if (daysRemaining <= 15) {
        urgencyLevel = 'critical';
        urgencyClass = 'banner-critical';
      } else if (daysRemaining <= 20) {
        urgencyLevel = 'warning';
        urgencyClass = 'banner-warning';  
      } else if (daysRemaining <= 30) {
        urgencyLevel = 'caution';
        urgencyClass = 'banner-caution';
      } else {
        urgencyLevel = 'safe';
        urgencyClass = 'banner-safe';
      }
      
      return { urgencyLevel, urgencyClass, daysRemaining };
    },

    // NEW: Handle extension request (UI only)
    requestExtension(project, event) {
      event.stopPropagation(); // Prevent project selection
      
      this.$emit('notify', {
        type: 'info',
        message: `Extension request for "${project.project_name}" will be available soon.`
      });
    }
  }
};
</script>

<style scoped>
 
/* Light theme accents */
:root[data-theme="light"] .tier-badge {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #991b1b;
  border: 1px solid #fca5a5;
}

:root[data-theme="light"] .header {
  border: 2px solid #fca5a5;
  box-shadow: 0 2px 8px rgba(212, 47, 61, 0.08);
}

:root[data-theme="light"] .create-btn {
  border: 2px solid #fca5a5;
}

:root[data-theme="light"] .project-banner {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(212, 47, 61, 0.1);
}
/* ADD dark theme border styling: */

:root[data-theme="dark"] .header {
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
/* Base Styles  */
.client-landing {
  min-height: 100vh;
  background: var(--background-color);
  padding: 2rem;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  background:var(--background-color);
  backdrop-filter: blur(10px);
  color: var(--text-color);
  border: 1px solid var(--border-color);
  border-radius: 2rem;

}

.company-info h1 {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.875rem;
  margin: 0;
  color: var(--text-color);

}
/*meta company */

.company-meta {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-top: 0.75rem;
  flex-wrap: wrap;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: var(--text-color);
  opacity: 0.8;
  padding: 0.375rem 0.75rem;
  background: var(--surface-color);
  border-radius: 0.5rem;
  border: 1px solid var(--border-color);
}

.meta-item i {
  color: var(--primary-color);
  font-size: 0.75rem;
}

/* Light theme accent for meta items */
:root[data-theme="light"] .meta-item {
  background: #fff5f5;
  border-color: #fca5a5;
}

.tier-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 2rem;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: var(--surface-color);
  color: var(--text-color);
  border: 1px solid var(--border-color);
}

.tier-basic { background: linear-gradient(135deg, #6b7280, #4b5563); }
.tier-pro { background: linear-gradient(135deg, #f59e0b, #d97706); }
.tier-enterprise { background: linear-gradient(135deg, #8b5cf6, #7c3aed); }

.main-content {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

/* Empty State - UNCHANGED */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 2rem;
  opacity: 0.6;
}

.create-first-btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 1rem 2rem;
  border-radius: 0.75rem;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 2rem auto 0;
  backdrop-filter: blur(4px);
}

.create-first-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

/* Section Header */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.section-header h2 {
  font-size: 1.75rem;
  margin: 0;
  color: var(--text-color);

}


.create-btn {
  background: var(--surface-color);
  color: var(--text-color);
  border: 2px solid var(--border-color);
  padding: 0.75rem 1.5rem;
  border-radius: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.create-btn:hover:not(:disabled) {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(212, 47, 61, 0.25);
}

.create-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* NEW: Projects Banners Layout */
.projects-banners {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 2rem;
}

.project-banner {
  position: relative;
  border-radius: 0.75rem;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border-left: 4px solid transparent;
}

.project-banner:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

/* Urgency Color Schemes */
.banner-safe {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border-left-color: #065f46;
}

.banner-caution {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  border-left-color: #92400e;
}

.banner-warning {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  border-left-color: #991b1b;
}

.banner-critical {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  border-left-color: #7f1d1d;
}

.banner-overdue {
  background: linear-gradient(135deg, #b91c1c 0%, #7f1d1d 100%);
  border-left-color: #450a0a;
  animation: pulse-urgent 2s infinite;
}

@keyframes pulse-urgent {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.8; }
}

.project-inactive {
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%) !important;
  border-left-color: #374151 !important;
  opacity: 0.7;
}

/* AFTER: */
.banner-content {
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  color: white !important;
  position: relative;
  z-index: 2;
}

.banner-content *:not(button):not(.extension-btn) {
  color: white !important;
}

.project-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  backdrop-filter: blur(4px);
}

.project-icon i {
  font-size: 1.25rem;
  color: white;
}

.project-info {
  flex: 1;
  min-width: 0;
}

.project-main {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
}

.company-name {
  font-size: 1.125rem;
  font-weight: 700;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.project-name {
  font-size: 1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  position: relative;
}

.project-name::before {
  content: "•";
  margin-right: 0.75rem;
  color: rgba(255, 255, 255, 0.6);
}

.project-status-badge {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.125rem 0.5rem;
  border-radius: 0.75rem;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.project-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
}

.job-title {
  font-style: italic;
}

.tier-info {
  font-weight: 500;
}

.project-progress {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.positions-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.positions-text {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.progress-bar {
  width: 120px;
  height: 6px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 3px;
  transition: width 0.3s ease;
}

.urgency-info {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 600;
}

.days-remaining {
  color: rgba(255, 255, 255, 0.9);
}

.overdue-text {
  color: #fef2f2;
  animation: pulse-text 1.5s infinite;
}

@keyframes pulse-text {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.project-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}

.extension-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(4px);
}

.extension-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: scale(1.05);
}

.extension-btn.urgent {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.6);
  animation: pulse-button 2s infinite;
}

@keyframes pulse-button {
  0%, 100% { box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4); }
  50% { box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.2); }
}

.select-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  transition: all 0.2s ease;
}

.project-banner:hover .select-indicator {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.1);
}

.select-indicator i {
  font-size: 0.875rem;
  color: white;
}

.urgency-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: rgba(255, 255, 255, 0.3);
}

/* Create Project Modal - UNCHANGED but keeping for completeness */
.create-project-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
 

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

/* Modal Content - Base */
.modal-content {
  position: relative;
  background: var(--surface-color);
  color: var(--text-color);
  border-radius: 1rem;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border: 2px solid var(--border-color);
}

/* Light theme modal - very light pink */
:root[data-theme="light"] .modal-content {
  background: linear-gradient(135deg, #fff5f5 0%, #ffff 100%);
  border-color: #fca5a5;
  box-shadow: 0 20px 25px -5px rgba(212, 47, 61, 0.1), 0 10px 10px -5px rgba(212, 47, 61, 0.05);
}

 

/* Modal Header */

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 2px solid var(--border-color);
  color: var(--text-color);
}

:root[data-theme="light"] .modal-header {
  border-bottom-color: #fca5a5;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), transparent);
}

:root[data-theme="dark"] .modal-header {
  border-bottom-color: rgba(212, 47, 61, 0.3);
}

.modal-header h2 {
  margin: 0;
  color: var(--text-color);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.modal-header h2 i {
  color: var(--primary-color);
}

.close-btn {
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--text-color);
  padding: 0.5rem;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
  transform: rotate(90deg);
}

:root[data-theme="light"] .close-btn {
  background: #fff5f5;
  border-color: #fca5a5;
  color: #991b1b;
}

:root[data-theme="dark"] .close-btn {
  background: rgba(212, 47, 61, 0.1);
  border-color: rgba(212, 47, 61, 0.3);
}

/* Form Steps */

.form-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem 0;
  padding: 0 2rem;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.step.active {
  opacity: 1;
}

.step.completed {
  opacity: 0.8;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--surface-color);
  border: 2px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
  color: var(--text-color);
}

.step.active .step-number {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.step.completed .step-number {
  background: #4CAF50;
  color: white;
  border-color: #4CAF50;
}

.step-label {
  font-size: 0.9rem;
  text-align: center;
  color: var(--text-color);
}

.step-divider {
  width: 60px;
  height: 2px;
  background: var(--border-color);
  margin: 0 1rem;
}

:root[data-theme="light"] .step-divider {
  background: #fca5a5;
}

:root[data-theme="dark"] .step-divider {
  background: rgba(212, 47, 61, 0.3);
}
/* Form Content */
.project-form {
  padding: 0 2rem 2rem;
}

.form-step-content {
  min-height: 400px;
}
 

/* Form Layout */
.form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.form-group {
  flex: 1;
}

.form-group.half-width {
  flex: 0.5;
}
/* REPLACE form input styling with: */

.form-step-content h3 {
  margin-bottom: 1.5rem;
  color: var(--text-color);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-step-content h3 i {
  color: var(--primary-color);
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--text-color);
  font-weight: 600;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid var(--border-color);
  border-radius: 8px;
  background: var(--surface-color);
  color: var(--text-color);
  font-size: 0.95rem;
  transition: all 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(212, 47, 61, 0.1);
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: var(--text-color);
  opacity: 0.5;
}

/* Light theme inputs */
:root[data-theme="light"] .form-group input,
:root[data-theme="light"] .form-group select,
:root[data-theme="light"] .form-group textarea {
  background: white;
  border-color: #fca5a5;
}

:root[data-theme="light"] .form-group input:focus,
:root[data-theme="light"] .form-group select:focus,
:root[data-theme="light"] .form-group textarea:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(212, 47, 61, 0.15);
}

/* :root[data-theme="dark"] .form-group input,
:root[data-theme="dark"] .form-group select,
:root[data-theme="dark"] .form-group textarea {
  background: rgba(212, 47, 61, 0.05);
  border-color: rgba(212, 47, 61, 0.3);
}Dark theme inputs */


/* Fix select dropdown options */
.form-group select option {
  background: var(--surface-color);
  color: var(--text-color);
}

:root[data-theme="light"] .form-group select option {
  background: white;
  color: #2a2a28;
}

:root[data-theme="dark"] .form-group select option {
  background: #1a0f0f;
  color: white;
}

.field-hint {
  display: block;
  margin-top: 0.5rem;
  color: var(--text-color);
  opacity: 0.7;
  font-size: 0.85rem;
}

.field-hint i {
  margin-right: 0.25rem;
  color: var(--primary-color);
}

/* Experience Controls */
.experience-controls {
  position: relative;
}
 

.experience-presets {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}
/* REPLACE range input styling with: */

.range-input {
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: var(--border-color);
  outline: none;
  -webkit-appearance: none;
  margin-bottom: 1rem;
}

:root[data-theme="light"] .range-input {
  background: #fca5a5;
}


.range-input::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--primary-color);
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(212, 47, 61, 0.3);
  border: 2px solid white;
}

.range-input::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--primary-color);
  cursor: pointer;
  border: 2px solid white;
  box-shadow: 0 2px 6px rgba(212, 47, 61, 0.3);
}

.preset-btn {
  padding: 0.5rem 1rem;
  border: 2px solid var(--border-color);
  border-radius: 20px;
  background: var(--surface-color);
  color: var(--text-color);
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.preset-btn:hover {
  background: var(--hover-color);
  border-color: var(--primary-color);
}

.preset-btn.active {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

:root[data-theme="light"] .preset-btn {
  background: white;
  border-color: #fca5a5;
  color: #991b1b;
}

:root[data-theme="dark"] .preset-btn {
  background: rgba(212, 47, 61, 0.1);
  border-color: rgba(212, 47, 61, 0.3);
}

/* Form Actions */
/* REPLACE form action buttons with: */

.form-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 2px solid var(--border-color);
}

:root[data-theme="light"] .form-actions {
  border-top-color: #fca5a5;
}

:root[data-theme="dark"] .form-actions {
  border-top-color: rgba(212, 47, 61, 0.3);
}

.back-btn,
.next-btn,
.submit-btn {
  padding: 0.75rem 1.5rem;
  border: 2px solid var(--border-color);
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
}

.back-btn {
  background: var(--surface-color);
  color: var(--text-color);
  border-color: var(--border-color);
}

.back-btn:hover {
  background: var(--hover-color);
  transform: translateX(-2px);
}

:root[data-theme="light"] .back-btn {
  background: white;
  border-color: #fca5a5;
  color: #991b1b;
}

:root[data-theme="dark"] .back-btn {
  background: rgba(212, 47, 61, 0.1);
  border-color: rgba(212, 47, 61, 0.3);
}

.next-btn,
.submit-btn {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.next-btn:hover:not(:disabled),
.submit-btn:hover:not(:disabled) {
  background: #b52835;
  border-color: #b52835;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(212, 47, 61, 0.3);
}

.next-btn:disabled,
.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}
/* Responsive Design */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    margin: 1rem;
  }
  
  .form-row {
    flex-direction: column;
    gap: 0;
  }
  
  .form-group.half-width {
    flex: 1;
  }
  
  .form-steps {
    flex-direction: column;
    gap: 1rem;
  }
  
  .step-divider {
    width: 2px;
    height: 30px;
    margin: 0;
  }
  
  .form-actions {
    flex-direction: column;
    gap: 1rem;
  }
  
  .back-btn,
  .next-btn,
  .submit-btn {
    width: 100%;
    justify-content: center;
  }


  
}

/* COMPACT BANNER LAYOUT */
.projects-banners {
  display: flex;
  flex-direction: column;
  gap: 1rem; /* Reduced from 1.5rem */
  margin-top: 1.5rem; /* Reduced from 2rem */
}

.project-banner {
  position: relative;
  border-radius: 0.5rem; /* Reduced from 0.75rem */
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Lighter shadow */
  border-left: 3px solid transparent; /* Reduced from 4px */
}

.project-banner:hover {
  transform: translateY(-1px); /* Reduced from -2px */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* Simplified shadow */
}

/* COMPACT BANNER CONTENT */
.banner-content {
  padding: 1rem; /* Reduced from 1.5rem */
  display: flex;
  align-items: center;
  gap: 1rem; /* Reduced from 1.5rem */
  color: white;
  position: relative;
  z-index: 2;
}

/* SMALLER PROJECT ICON */
.project-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem; /* Reduced from 3rem */
  height: 2.25rem;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  backdrop-filter: blur(4px);
}

.project-icon i {
  font-size: 1rem; /* Reduced from 1.25rem */
  color: white;
}

/* SIMPLIFIED PROJECT INFO */
.project-info {
  flex: 1;
  min-width: 0;
  line-height: 1.3;
}

.project-main {
  display: flex;
  align-items: center;
  gap: 0.5rem; /* Reduced from 0.75rem */
  margin-bottom: 0.25rem; /* Reduced from 0.5rem */
  flex-wrap: wrap;
}

/* PROJECT NAME AS PRIMARY (no bullet point) */
.project-name-primary {
  font-size: 1rem; /* Primary font size */
  font-weight: 700; /* Bold for prominence */
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* COMPACT STATUS BADGE */
.project-status-badge {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.125rem 0.375rem; /* Slightly reduced */
  border-radius: 0.5rem; /* Reduced from 0.75rem */
  font-size: 0.65rem; /* Reduced from 0.75rem */
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

/* SIMPLIFIED META INFO */
.project-meta {
  display: flex;
  align-items: center;
  gap: 0.75rem; /* Reduced from 1rem */
  font-size: 0.75rem; /* Reduced from 0.875rem */
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0.5rem; /* Reduced from 0.75rem */
  flex-wrap: wrap;
}

.job-title {
  font-style: italic;
  font-weight: 500;
}

.tier-info {
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
}

.budget-info {
  font-weight: 600;
  color: #4ade80; /* Green for money */
}

/* COMPACT PROGRESS */
.project-progress {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.positions-info {
  display: flex;
  align-items: center;
  gap: 0.75rem; /* Reduced from 1rem */
}

.positions-text {
  font-size: 0.75rem; /* Reduced from 0.875rem */
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.progress-bar {
  width: 80px; /* Reduced from 120px */
  height: 4px; /* Reduced from 6px */
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 2px;
  transition: width 0.3s ease;
}

.urgency-info {
  font-size: 0.75rem; /* Reduced from 0.875rem */
  font-weight: 600;
}

.days-remaining {
  color: rgba(255, 255, 255, 0.9);
}

.overdue-text {
  color: #fef2f2;
  animation: pulse-text 1.5s infinite;
}

/* COMPACT ACTION BUTTONS */
.project-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem; /* Reduced from 1rem */
  flex-shrink: 0;
}

.extension-btn {
  display: flex;
  align-items: center;
  gap: 0.25rem; /* Reduced from 0.5rem */
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 0.375rem 0.75rem; /* Reduced from 0.5rem 1rem */
  border-radius: 0.375rem; /* Reduced from 0.5rem */
  font-size: 0.7rem; /* Reduced from 0.875rem */
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(4px);
}

.extension-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

/* MOBILE RESPONSIVENESS */
@media (max-width: 768px) {
  .banner-content {
    padding: 0.75rem;
    gap: 0.75rem;
    flex-direction: column;
    text-align: center;
  }
  
  .project-icon {
    width: 2rem;
    height: 2rem;
  }
  
  .project-icon i {
    font-size: 0.875rem;
  }
  
  .project-main {
    flex-direction: column;
    gap: 0.25rem;
    align-items: center;
  }
  
  .project-meta {
    justify-content: center;
    gap: 0.5rem;
  }
  
  .project-progress {
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
  }
  
  .extension-btn {
    align-self: stretch;
    justify-content: center;
  }
}

/* Maintain existing urgency color schemes and animations */
.banner-safe { background: linear-gradient(135deg, #10b981 0%, #059669 100%); border-left-color: #065f46; }
.banner-caution { background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); border-left-color: #92400e; }
.banner-warning { background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%); border-left-color: #991b1b; }
.banner-critical { background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%); border-left-color: #7f1d1d; }
.banner-overdue { background: linear-gradient(135deg, #b91c1c 0%, #7f1d1d 100%); border-left-color: #450a0a; animation: pulse-urgent 2s infinite; }
.project-inactive { background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%) !important; border-left-color: #374151 !important; opacity: 0.7; }

@keyframes pulse-urgent {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.8; }
}

@keyframes pulse-text {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}
/* Header actions container */
.header-actions {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.view-all-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background: var(--surface-color);
  color: var(--text-color);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
}

.view-all-btn:hover {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}
.btn {
  padding: 0.7rem 1.4rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
}
.btn-secondary {
  background: #6c757d;
  color: white;
  border: none;
}
.btn-primary {
  background: var(--primary-color, #b52835);
  color: white;
  border: none;
}
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.link-entry {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
}
.link-label-input {
  flex: 0 0 180px;
}
.link-url-input {
  flex: 1;
}
.remove-link-btn {
  background: none;
  border: none;
  color: #fc8181;
  cursor: pointer;
  padding: 4px 6px;
  font-size: 0.85rem;
}
.remove-link-btn:hover { color: #e53e3e; }

.hide-btn {
  display: flex;
  align-items: center;
  background: rgba(0,0,0,0.2);
  color: white;
  border: 1px solid rgba(255,255,255,0.2);
  padding: 0.375rem 0.5rem;
  border-radius: 0.375rem;
  font-size: 0.7rem;
  cursor: pointer;
  transition: all 0.2s ease;
}
.hide-btn:hover { background: rgba(0,0,0,0.4); }

.archive-footer {
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
}
.archive-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--surface-color);
  color: var(--text-color);
  border: 1px solid var(--border-color);
  padding: 0.5rem 1.25rem;
  border-radius: 2rem;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
}
.archive-toggle-btn:hover { border-color: var(--primary-color); color: var(--primary-color); }
.archive-count {
  background: var(--primary-color);
  color: white;
  border-radius: 1rem;
  padding: 0.1rem 0.5rem;
  font-size: 0.75rem;
}

.archived-section {
  margin-top: 1rem;
  border: 1px solid var(--border-color);
  border-radius: 0.75rem;
  overflow: hidden;
}
.archived-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--border-color);
  background: var(--surface-color);
  opacity: 0.7;
}
.archived-banner:last-child { border-bottom: none; }
.archived-info { display: flex; flex-direction: column; gap: 0.2rem; }
.archived-name { font-size: 0.9rem; font-weight: 600; color: var(--text-color); }
.archived-job { font-size: 0.78rem; color: var(--text-color); opacity: 0.6; font-style: italic; }
.restore-btn {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  background: none;
  border: 1px solid var(--border-color);
  color: var(--text-color);
  padding: 0.3rem 0.75rem;
  border-radius: 0.375rem;
  font-size: 0.78rem;
  cursor: pointer;
  transition: all 0.2s ease;
}
.restore-btn:hover { border-color: #4ade80; color: #4ade80; }
.archive-empty {
  padding: 1.5rem;
  text-align: center;
  color: var(--text-color);
  opacity: 0.5;
  font-size: 0.9rem;
}
</style>